import { useEffect, useCallback } from "react";
import { usePageHeader } from "../context/PageHeaderContext";

export default function PageHeader({
  title,
  subtitle,
  icon: Icon,
  iconContainerClassName,
  iconClassName,
  showInPage = false, // Mostra in pagina invece che nell'header
  /** Azioni opzionali (es. toggle vista) mostrate in header desktop e accanto al titolo su mobile */
  actions = null,
}) {
  const { setHeader, clearHeader } = usePageHeader();

  const headerData = useCallback(() => ({
    title,
    subtitle,
    Icon,
    iconContainerClassName,
    iconClassName,
    actions,
  }), [title, subtitle, Icon, iconContainerClassName, iconClassName, actions]);

  useEffect(() => {
    if (!showInPage) {
      setHeader(headerData());
    }

    return () => {
      if (!showInPage) {
        clearHeader();
      }
    };
  }, [showInPage, setHeader, clearHeader, headerData]);

  if (!showInPage) return null;

  return (
    <div className="mb-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          {Icon && (
            <div
              className={`w-11 h-11 rounded-xl flex items-center justify-center shadow-sm shrink-0 ${
                iconContainerClassName || "bg-slate-100"
              }`}
            >
              <Icon
                className={`w-5 h-5 ${iconClassName || "text-slate-700"}`}
              />
            </div>
          )}
          <div className="min-w-0">
            <h1 className="text-2xl font-bold text-slate-900 leading-tight">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm text-slate-500 mt-1">{subtitle}</p>
            )}
          </div>
        </div>
        {actions ? <div className="shrink-0">{actions}</div> : null}
      </div>
    </div>
  );
}
